<vi-global-spinner></vi-global-spinner>
<app-splash-screen></app-splash-screen>

<app-header *ngIf="!embedModeEnabled"></app-header>
<app-maintenance-banner *ngIf="!embedModeEnabled"></app-maintenance-banner>

<div class="app-content d-flex flex-column">
  <router-outlet></router-outlet>
</div>

<dsw-footer *ngIf="!embedModeEnabled" [accessibilityUrl]="accessibilityUrl"></dsw-footer>

<!--div id="breakpoint-debug-output"></div-->
